export default [
  //平台设置
  {
    name: "GetAppearanceSetting",
    url: "/appearance/get",
    method: "GET",
    mock: false,
  },
  {
    name: "SaveAppearanceSetting",
    url: "/appearance/save",
    method: "POST",
    mock: false,
  },
  {
    name: "GetCompanySetting",
    url: "/company/get",
    method: "GET",
    mock: false,
  },
  {
    name: "SaveCompanySetting",
    url: "/company/save",
    method: "POST",
    mock: false,
  },
  {
    name: "GetSecuritySetting",
    url: "/security/get",
    method: "GET",
    mock: false,
  },
  {
    name: "SaveSecuritySetting",
    url: "/security/save",
    method: "POST",
    mock: false,
  },
  {
    name: "GetLanguageList",
    url: "/language/list",
    method: "GET",
    mock: false,
  },
  //CRM设置——牌照设置
  //牌照删除
  {
    name: "DeleteLicense",
    url: "/license/delete",
    method: "POST",
    mock: false,
  },
  //牌照获取
  {
    name: "GetLicense",
    url: "/license/get",
    method: "GET",
    mock: false,
  },
  //牌照列表
  {
    name: "GetLicenseList",
    url: "/license/list",
    method: "GET",
    mock: false,
  },
  //交易账户牌照下拉列表
  {
    name: "GetTradingAccountLicenseList",
    url: "/trading-account/list-license",
    method: "GET",
    mock: false,
  },
  //牌照创建
  {
    name: "CreateLicense",
    url: "/license/create",
    method: "POST",
    mock: false,
  },
  //牌照创建
  {
    name: "UpdateLicense",
    url: "/license/update",
    method: "POST",
    mock: false,
  },
  //CRM设置——注册流程设置
  //注册流程牌照设置删除
  // {
  //   name: "DeleteRegisterFlowLicense",
  //   url: "/license-register/delete",
  //   method: "POST",
  //   mock: false,
  // },
  //注册流程牌照设置获取
  // {
  //   name: "GetRegisterFlowLicense",
  //   url: "/license-register/get",
  //   method: "GET",
  //   mock: false,
  // },
  //注册流程牌照设置列表
  // {
  //   name: "GetRegisterFlowLicenseList",
  //   url: "/license-register/list",
  //   method: "GET",
  //   mock: false,
  // },
  //注册流程牌照设置保存
  // {
  //   name: "SaveRegisterFlowLicense",
  //   url: "/license-register/update",
  //   method: "POST",
  //   mock: false,
  // },

  //KYC配置获取
  {
    name: "GetRegisterTemplate",
    url: "/register/get-template",
    method: "GET",
    mock: false,
  },

  //CRM设置——注册流程
  //注册流程删除
  {
    name: "DeleteRegisterFlow",
    url: "/register/delete",
    method: "POST",
    mock: false,
  },
  //注册流程获取
  {
    name: "GetRegisterFlow",
    url: "/register/get",
    method: "GET",
    mock: false,
  },
  //注册流程列表
  {
    name: "GetRegisterFlowList",
    url: "/register/list",
    method: "GET",
    mock: false,
  },
  //注册流程保存
  {
    name: "CreateRegisterFlow",
    url: "/register/create",
    method: "POST",
    mock: false,
  },
  {
    name: "UpdateRegisterFlow",
    url: "/register/update",
    method: "POST",
    mock: false,
  },
  // 全局杠杆相关接口
  // 创建全局杠杆
  {
    name: "CreateGlobalLeverage",
    url: "/global-leverage/create",
    method: "POST",
    mock: false,
  },
  // 删除全局杠杆
  {
    name: "DeleteGlobalLeverage",
    url: "/global-leverage/delete",
    method: "POST",
    mock: false,
  },
  // 更新全局杠杆
  {
    name: "UpdateGlobalLeverage",
    url: "/global-leverage/update",
    method: "POST",
    mock: false,
  },
  // 查询全局杠杆
  {
    name: "GetGlobalLeverage",
    url: "/global-leverage/get",
    method: "GET",
    mock: false,
  },

  // 查询可用杠杆值选项列表
  {
    name: "ListAvailableLeverageOptions",
    url: "/global-leverage/list-options",
    method: "GET",
    mock: false,
  },

  // 交易账户类型管理相关接口
  // 创建交易账号类型
  {
    name: "CreateTradingAccountType",
    url: "/trading-account-type/create",
    method: "POST",
    mock: false,
  },
  // 删除交易账号类型
  {
    name: "DeleteTradingAccountType",
    url: "/trading-account-type/delete",
    method: "POST",
    mock: false,
  },
  // 更新交易账号类型
  {
    name: "UpdateTradingAccountType",
    url: "/trading-account-type/update",
    method: "POST",
    mock: false,
  },
  // 查询交易账号类型
  {
    name: "GetTradingAccountType",
    url: "/trading-account-type/get",
    method: "GET",
    mock: false,
  },
  // 注册流程————查询可用交易服务器列表
  {
    name: "GetRegistrationAccountByTradingServer",
    url: "/trading-account-type/list-available-server",
    method: "GET",
    mock: false,
  },
  // 查询交易账号类型列表
  {
    name: "ListTradingAccountType",
    url: "/trading-account-type/list",
    method: "GET",
    mock: false,
  },
  //交易服务器————交易服务器配置
  //创建交易服务器
  {
    name: "CreateTradingServer",
    url: "/trading-server/create",
    method: "POST",
    mock: false,
  },
  //更新交易服务器
  {
    name: "UpdateTradingServer",
    url: "/trading-server/update",
    method: "POST",
    mock: false,
  },
  //删除交易服务器
  {
    name: "DeleteTradingServer",
    url: "/trading-server/delete",
    method: "POST",
    mock: false,
  },
  //获取交易服务器
  {
    name: "GetTradingServer",
    url: "/trading-server/get",
    method: "GET",
    mock: false,
  },
  //查询交易服务器配置列表
  {
    name: "GetTradingServerList",
    url: "/trading-server/list",
    method: "GET",
    mock: false,
  },
  //更新交易服务器连接
  {
    name: "UpdateTradingServerConnection",
    url: "/trading-server/update-connection",
    method: "POST",
    mock: false,
  },
  //查询交易服务器类型选项列表
  {
    name: "ListTradingServerTypeOptions",
    url: "/trading-server/list-type",
    method: "GET",
    mock: false,
  },
  //创建交易账户类型的注册流程绑定
  {
    name: "CreateBindingRegisterProcess",
    url: "/trading-account-type/create-binding-register-process",
    method: "POST",
    mock: false,
  },
  //删除交易账户类型的注册流程绑定
  {
    name: "DeleteBindingRegisterProcess",
    url: "/trading-account-type/delete-binding-register-process",
    method: "POST",
    mock: false,
  },
  //创建入金设置
  {
    name: "CreateDepositSetting",
    url: "/deposit/create",
    method: "POST",
    mock: false,
  },
  //更新入金设置
  {
    name: "UpdateDepositSetting",
    url: "/deposit/update",
    method: "POST",
    mock: false,
  },
  //删除入金设置
  {
    name: "DeleteDepositSetting",
    url: "/deposit/delete",
    method: "POST",
    mock: false,
  },
  //获取入金设置列表
  {
    name: "ListDepositSetting",
    url: "/deposit/list",
    method: "GET",
    mock: false,
  },
  //获取入金设置详情
  {
    name: "GetDepositSetting",
    url: "/deposit/detail",
    method: "GET",
    mock: false,
  },
  // 修改入金设置状态: 启用/禁用
  {
    name: "UpdateDepositSettingStatus",
    url: "/deposit/status/update",
    method: "POST",
    mock: false,
  },
  //获取第三方入金设置列表
  {
    name: "ListThirdPartyDepositSetting",
    url: "/deposit/third-party/list",
    method: "GET",
    mock: false,
  },
  //获取第三方入金设置详情
  {
    name: "GetThirdPartyDepositSetting",
    url: "/deposit/third-party/detail",
    method: "GET",
    mock: false,
  },
  //更新第三方入金设置
  {
    name: "UpdateThirdPartyDepositSetting",
    url: "/deposit/third-party/update",
    method: "POST",
    mock: false,
  },
  //更新第三方入金设置状态
  {
    name: "UpdateThirdPartyDepositSettingStatus",
    url: "/deposit/third-party/status/update",
    method: "POST",
    mock: false,
  },
  //创建出金设置
  {
    name: "CreateWithdrawalSetting",
    url: "/withdrawal/create",
    method: "POST",
    mock: false,
  },
  //删除出金设置
  {
    name: "DeleteWithdrawalSetting",
    url: "/withdrawal/delete",
    method: "POST",
    mock: false,
  },
  //更新出金设置
  {
    name: "UpdateWithdrawalSetting",
    url: "/withdrawal/update",
    method: "POST",
    mock: false,
  },
  //更新出金设置状态
  {
    name: "UpdateWithdrawalSettingStatus",
    url: "/withdrawal/change/status",
    method: "POST",
    mock: false,
  },
  //获取出金设置列表
  {
    name: "ListWithdrawalSetting",
    url: "/withdrawal/list",
    method: "GET",
    mock: false,
  },
  //获取出金设置详情
  {
    name: "GetWithdrawalSetting",
    url: "/withdrawal/detail",
    method: "GET",
    mock: false,
  },
  //获取汇率服务商列表
  {
    name: "ListSymbolRateService",
    url: "/symbol-rate-service/list",
    method: "GET",
    mock: false,
  },
  //更新汇率服务商
  {
    name: "UpdateSymbolRateService",
    url: "/symbol-rate-service/update",
    method: "POST",
    mock: false,
  },
  //创建汇率配置
  {
    name: "CreateSymbolRate",
    url: "/symbol-rate/create",
    method: "POST",
    mock: false,
  },
  // 删除汇率配置
  {
    name: "DeleteSymbolRate",
    url: "/symbol-rate/delete",
    method: "POST",
    mock: false,
  },
  //获取汇率列表
  {
    name: "ListSymbolRate",
    url: "/symbol-rate/list",
    method: "GET",
    mock: false,
  },
  // 更新汇率配置
  {
    name: "UpdateSymbolRate",
    url: "/symbol-rate/update",
    method: "POST",
    mock: false,
  },
  // 更新汇率服务商状态
  {
    name: "UpdateSymbolRateServiceStatus",
    url: "/symbol-rate-service/status/update",
    method: "POST",
    mock: false,
  },
  // 工具/下载相关接口
  //创建软件下载工具
  {
    name: "CreateToolSetting",
    url: "/tool/create",
    method: "POST",
    mock: false,
  },
  // 删除软件下载工具
  {
    name: "DeleteToolSetting",
    url: "/tool/delete",
    method: "POST",
    mock: false,
  },
  //获取软件下载工具详情
  {
    name: "GetToolSetting",
    url: "/tool/get",
    method: "GET",
    mock: false,
  },
  //获取软件下载工具列表
  {
    name: "ListToolSetting",
    url: "/tool/list",
    method: "GET",
    mock: false,
  },
  // 更新软件下载工具
  {
    name: "UpdateToolSetting",
    url: "/tool/update",
    method: "POST",
    mock: false,
  },
  // 邮件相关接口
  // 创建邮件服务器设置
  {
    name: "CreateEmailServerSetting",
    url: "/email-server/create",
    method: "POST",
    mock: false,
  },
  // 删除邮件服务器设置
  {
    name: "DeleteEmailServerSetting",
    url: "/email-server/delete",
    method: "POST",
    mock: false,
  },
  // 查询邮件服务器设置详情
  {
    name: "GetEmailServerSetting",
    url: "/email-server/get",
    method: "GET",
    mock: false,
  },
  // 查询邮件服务器设置列表
  {
    name: "ListEmailServerSetting",
    url: "/email-server/list",
    method: "GET",
    mock: false,
  },
  // 发送测试邮件
  {
    name: "SendTestEmail",
    url: "/email-server/test",
    method: "POST",
    mock: false,
  },
  // 更新邮件服务器设置
  {
    name: "UpdateEmailServerSetting",
    url: "/email-server/update",
    method: "POST",
    mock: false,
  },
  // 获取可配置的三方邮件服务列表
  {
    name: "ListEmailThirdPartyEmailService",
    url: "/email-server/provider/list",
    method: "GET",
    mock: false,
  },
  // 创建邮件模板
  {
    name: "CreateEmailTemplate",
    url: "/email-template/create",
    method: "POST",
    mock: false,
  },
  // 删除邮件模板
  {
    name: "DeleteEmailTemplate",
    url: "/email-template/delete",
    method: "POST",
    mock: false,
  },

  // 查询邮件模板详情
  {
    name: "GetEmailTemplate",
    url: "/email-template/get",
    method: "GET",
    mock: false,
  },
  // 查询邮件模板列表
  {
    name: "ListEmailTemplate",
    url: "/email-template/list",
    method: "GET",
    mock: false,
  },
  // 查询模板可用业务变量
  {
    name: "ListTemplateVariable",
    url: "/email-template/list-available-variable",
    method: "GET",
    mock: false,
  },
  // 查询可选触发行为选项列表
  {
    name: "ListTriggerAction",
    url: "/email-template/list-trigger-action",
    method: "GET",
    mock: false,
  },
  // 查询可选触发对象选项列表
  {
    name: "ListTriggerObject",
    url: "/email-template/list-trigger-object",
    method: "GET",
    mock: false,
  },

  // 发送测试模板邮件
  {
    name: "SendTestTemplateEmail",
    url: "/email-template/test",
    method: "POST",
    mock: false,
  },
  // 更新邮件模板
  {
    name: "UpdateEmailTemplate",
    url: "/email-template/update",
    method: "POST",
    mock: false,
  },
  // 更改邮件模板状态
  {
    name: "UpdateEmailTemplateStatus",
    url: "/email-template/update-status",
    method: "POST",
    mock: false,
  },

  // 查询模板默认正文
  {
    name: "GetTemplateDefaultText",
    url: "/email-template/get-default-text",
    method: "GET",
    mock: false,
  },

  // 查询交易服务器状态列表——用于全局提示
  {
    name: "ListTradingServerStatus",
    url: "/trading-server/list-status",
    method: "GET",
    mock: false,
  },
  // 修改账户类型设置状态
  {
    name: "UpdateTradingAccountTypeStatus",
    url: "/trading-account-type/update-status",
    method: "POST",
    mock: false,
  },
  // 新增牌照账户数设置
  {
    name: "CreateAccountLimit",
    url: "/account-limit/create",
    method: "POST",
    mock: false,
  },
  // 查询账户数设置可选牌照列表
  {
    name: "ListAccountLimitLicense",
    url: "/account-limit/list-license",
    method: "GET",
    mock: false,
  },
  // 更新账户类型设置状态
  {
    name: "UpdateAccountLimit",
    url: "/account-limit/update",
    method: "POST",
    mock: false,
  },
  // 删除牌照账户数设置
  {
    name: "DeleteAccountLimit",
    url: "/account-limit/delete",
    method: "POST",
    mock: false,
  },
  // 获取牌照账户数设置
  {
    name: "GetAccountLimit",
    url: "/account-limit/get",
    method: "GET",
    mock: false,
  },
  // 获取牌照账户数设置列表
  {
    name: "ListAccountLimit",
    url: "/account-limit/list",
    method: "GET",
    mock: false,
  },
  // 获取交易账号类型可用组别
  {
    name: "GetGroupsByTradingServer",
    url: "/trading-account-type/get-groups",
    method: "GET",
    mock: false,
  },

  // 创建问卷配置
  {
    name: "CreateQuestionnaire",
    url: "/questionnaire/create",
    method: "POST",
    mock: false,
  },
  // 更新问卷配置
  {
    name: "UpdateQuestionnaire",
    url: "/questionnaire/update",
    method: "POST",
    mock: false,
  },
  // 更改问卷配置状态
  {
    name: "UpdateQuestionnaireStatus",
    url: "/questionnaire/update-status",
    method: "POST",
    mock: false,
  },
  // 删除问卷配置
  {
    name: "DeleteQuestionnaire",
    url: "/questionnaire/delete",
    method: "POST",
    mock: false,
  },
  // 获取问卷配置
  {
    name: "GetQuestionnaire",
    url: "/questionnaire/get",
    method: "GET",
    mock: false,
  },
  // 获取问卷配置列表
  {
    name: "ListQuestionnaire",
    url: "/questionnaire/list",
    method: "GET",
    mock: false,
  },
  // 获取问卷配置可选项列表
  {
    name: "ListQuestionnaireOptions",
    url: "/questionnaire/list-options",
    method: "GET",
    mock: false,
  },
];
